// eslint-disable-next-line import/prefer-default-export
export function isValidDimensao(dimensao) {
  return dimensao.peso || dimensao.altura || dimensao.largura || dimensao.comprimento;
}
